export default "__VITE_ASSET__CtUOq98d__"